module.exports = __webpack_public_path__ + "static/flags/GK-998aef34fbc94f65cbb3f0c439c87a39.gif";